export default "__VITE_ASSET__DhJj3JdS__"